import React from "react";
import useTableData from "../useTableData";
import {useAxiosSetup} from "../../Api";
import useEffectSkipFirst from "../../hooks/useEffectSkipFirst";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Cislo", "caption": "Číslo", 'filter': 'string', 'textStyle': 'bold'},
    {"label": "Produkty", "caption": "Produkty", 'filter': 'string'},
    {"label": "Pristroje", "caption": "S/N", 'filter': 'string'},
    {"label": "Nadpis", "caption": "Názov Prípadu", 'filter': 'string'},
    {"label": "Zakaznik", "caption": "Zákazník", 'filter': 'string'},
    {"label": "Datum_Otvorenia", "caption": "Dátum Otvorenia", 'filter': 'dateRange'},
    {"label": "Datum_Uzavretia", "caption": "Dátum Uzavretia", 'filter': 'dateRange'},
    {"label": "Objednavka", "caption": "Objednávka", 'filter': 'string'},
    {"label": "Datum_Objednavky", "caption": "Dátum Objednávky", 'filter': 'dateRange'},
    {"label": "Datum_Planovanej_BTK", "caption": "Dátum Plánovanej BTK", 'filter': 'dateRange'},
    {"label": "Stav__Stav", "caption": "Stav", 'filter': 'string', 'textStyle': 'bold'},
    {"label": "Zmena_Stavu", "caption": "Zmena Stavu", 'filter': 'dateRange'},
]

function BTKs(props) {
    const initialFilters = [
        {
            'label': 'Cislo',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Objednavky_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Objednavky_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Otvorenia_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Otvorenia_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Uzavretia_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Uzavretia_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zmena_Stavu_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zmena_Stavu_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zakaznik',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Nadpis',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Objednavka',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Stav__Stav',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Stav__Uzavrety',
        },
        {
            'label': 'Pristroje',
            'lookup': '_SNR',
            'value': '',
        },
        {
            'label': 'Produkty',
            'lookup': '',
            'value': '',
        },
    ]
    const baseUrl = '/btk/btks'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)
    const [colors, setColors] = React.useState()
    const api = useAxiosSetup();

    function parse_links(data) {
        return data.map(entry => ({
            'Cislo': `/btks/btk/${entry.id}`
        }))
    }

    function colorize() {
        // #TBD: Change from imperative to declarative
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0, 2) // Do not color table header
        new_rows.forEach((row, index) => {
            const stav = data[index].Stav
            const lastChange = data[index].Zmena_Stavu
            const stateCell = row.getElementsByTagName("td")[10]
            const stateChangeCell = row.getElementsByTagName("td")[11]
            if (stav !== null) {
                const colorState = stav["Farba"]
                stateCell.style.backgroundColor = colorState
            } else {
                stateCell.style.backgroundColor = "unset"
            }
            if (lastChange !== null && stav && !stav["Uzavrety"]) {
                const colorChange = getStateChangeColor(lastChange)
                stateChangeCell.style.backgroundColor = colorChange
            } else {
                stateChangeCell.style.backgroundColor = "unset"
            }
            const btkPlanCell = row.getElementsByTagName("td")[9]
            if (data[index].Datum_Planovanej_BTK !== null && stav && !stav["Uzavrety"]) {
                const colorBtk = getBtkPlanColor(data[index].Datum_Planovanej_BTK)
                btkPlanCell.style.backgroundColor = colorBtk
            }
        })
    }

    function getBtkPlanColor(datetime) {
        // Choose color based on how long until planned BTK
        const now = new Date()
        const plannedBtk = new Date(datetime)
        let plannedBtkDays = (plannedBtk - now) / (1000 * 60 * 60 * 24)
        if (plannedBtkDays < 0) plannedBtkDays = 0;
        if (plannedBtkDays > 100) plannedBtkDays = 100;

        const red = Math.floor(plannedBtkDays * 2.55);
        // const red = Math.floor((plannedBtkDays) * 2.55);
        const blue = 255;
        const green = Math.floor(plannedBtkDays * 2.55);
        return `rgb(${red},${green},${blue})`
    }

    function getStateChangeColor(datetime) {
        // Choose color based on how recently state was changed
        const now = new Date()
        const lastStateChange = new Date(datetime)
        let stateChangeDays = (now - lastStateChange) / (1000 * 60 * 60 * 24)
        if (stateChangeDays < 0) stateChangeDays = 0;
        if (stateChangeDays > 100) stateChangeDays = 100;

        const red = 255;
        // const red = Math.floor((stateChangeDays) * 2.55);
        const blue = Math.floor((100 - stateChangeDays) * 2.55);
        const green = Math.floor((100 - stateChangeDays) * 2.55);
        return `rgb(${red},${green},${blue})`
    }

    function getStateColors() {
        api.get('/btk/btks_states/list_with_links/?format=json').then((response) => {
            const data = JSON.parse(response.data.output)
            const newColors = data.map(entry => {
                return {
                    "stav": entry.Stav,
                    "farba": entry.Farba
                }
            })
            setColors(newColors)
        })
    }

    useEffectSkipFirst(() => {
        getStateColors()
    }, [data])

    React.useEffect(() => {
        colorize()
    }, [colors]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ListViewCommon baseUrlFrontend={`/btks/btk`}
                        noColorRows={true}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        deleteConfirmation={true}
                        deleteConfirmationText={"Naozaj chcete prípad odstrániť?"}
                        label={"BTK"}
        />
    )
}

export default BTKs
